/*
 * @Author: yangyang yyangacom@163.com
 * @Date: 2023-06-07 18:19:15
 * @LastEditors: yangyang yyangacom@163.com
 * @LastEditTime: 2023-06-29 17:10:48
 * @FilePath: /dbrank_b/src/routes/visualChart/components/Tooltip/index.js
 * @Description: tooltip
 */
import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './index.css';
import cx from 'classnames';
import PropTypes from 'prop-types'


class Tooltip extends React.Component {
  static propTypes = {
    content: PropTypes.node.isRequired,
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    wrapperClassName: PropTypes.string,
    style: PropTypes.object,
  }
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
    }
  }
  onMouseEnter = () => {
    this.setState({
      visible: true,
    });
  }
  onMouseLeave = () => {
    this.setState({
      visible: false,
    });
  }
  render() {
    const { visible } = this.state;
    const { content, wrapperClassName } = this.props;
    return (
      <div
        className={cx(s.root, this.props.className)}
        style={this.props.style}
        onMouseEnter={this.onMouseEnter}
        onMouseLeave={this.onMouseLeave}>
        {this.props.children}
        <div className={cx(s.wrapper, wrapperClassName, { [s.wrapperVisible]: visible })}>
          {content || 'tooltip'}
        </div>
      </div>
    );
  }
}

export default withStyles(s)(Tooltip);



// WEBPACK FOOTER //
// src/routes/visualChart/components/Tooltip/index.js